const EU = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
    'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT',
    'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
]

/**
 * Whether a parcel to this address needs a customs declaration because it leaves the EU customs and VAT territory.
 * Madeira and the Azores (Portuguese postal codes starting with 9) are part of PT but outside that territory.
 */
export function outsideEUCustoms(address: {country?: string, postalCode?: string}): boolean {
    if (address.country === 'PT' && (address.postalCode || '').trim().startsWith('9')) {
        return true
    }

    return !EU.includes(address.country)
}

export default EU
